import "core-js/modules/es.number.constructor";
//
//
//
//
export default {
  props: {
    type: {
      type: Number,
      default: 0 // 0活动规则|1灯牌规则

    },
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    ruleContent: function ruleContent() {
      // 榜单部分有两块规则 从props.content传入
      return this.type === 0 ? window.setting.活动规则 : this.content;
    }
  }
};